export class EncArrayBuffer {
  constructor(public buffer: ArrayBuffer) {}
}
